var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, List, ListItem } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import config from '../Config';
import { addLanguageSlugToUrl } from '../util/PathUtil';
import { frontPageGaData } from './FrontPageBlocks';
import { injectStores } from '../util/StoresUtil';
import { navigate } from '@teliaee/crm-components';
const BLOCK_NAME = 'Konto';
let UserBlock = class UserBlock extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { translate, currentLanguage } = this.translateStore;
        return (React.createElement(React.Fragment, null,
            React.createElement(List, { type: "unstyled", bordered: true },
                React.createElement(ListItem, null,
                    React.createElement(Button, { text: translate('userBlock.rightsAndMandates'), link: true, iconLeft: "#handshake", onClick: () => {
                            navigate('/konto#representation-rights');
                            frontPageGaData(BLOCK_NAME, 'Õigused ja volitused');
                        } })),
                React.createElement(ListItem, null,
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.userUrl, currentLanguage), text: translate('userBlock.numberHolderInfo'), link: true, iconLeft: "#contact", onClick: () => frontPageGaData(BLOCK_NAME, 'Numbri kasutaja andmed') })),
                React.createElement(ListItem, null,
                    React.createElement(Button, { text: translate('userBlock.customerServicePassword'), link: true, iconLeft: "#more", onClick: () => {
                            navigate('/konto#customer-service-password-tab');
                            frontPageGaData(BLOCK_NAME, 'Klienditeeninduse salasõna');
                        } })),
                React.createElement(ListItem, null,
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.offersSettingsUrl, currentLanguage), text: translate('userBlock.offerSettings'), link: true, iconLeft: "#like", onClick: () => frontPageGaData(BLOCK_NAME, 'Pakkumiste seaded') })))));
    }
};
UserBlock = __decorate([
    injectStores,
    observer
], UserBlock);
export default UserBlock;
